module.exports = __webpack_public_path__ + "static/media/full-slider-lp.bbb0c31b.jpg";